import { render, staticRenderFns } from "./FormEvento.vue?vue&type=template&id=dd1a7c3a&scoped=true"
import script from "./FormEvento.vue?vue&type=script&lang=js"
export * from "./FormEvento.vue?vue&type=script&lang=js"
import style0 from "./FormEvento.vue?vue&type=style&index=0&id=dd1a7c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1a7c3a",
  null
  
)

export default component.exports